import {  ISolutionHistory } from '@ebb-v2/ebb-integration';

import { IImportJob } from './../../models/importjob.interface';
// Core/Third Party
import { Component, OnInit } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { catchError, filter, switchMap, tap } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import { Observable, BehaviorSubject, Subject, of } from 'rxjs';
import { publishReplay, refCount, map, take, first } from 'rxjs/operators';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
// Components/Services/Directives/etc.
import { DialogData } from './components/policy-dialog/policy-dialog.component';
import { AuthService } from './../../services/auth/auth.service';
import { DwellingService } from '../../services/dwelling/dwelling.service';
// Queries/Mutations
import { POLICY_QUERY } from './../../graphql/queries/policy.query';
import { GET_QUESTIONNAIRES_QUERY } from '../../graphql/queries/questionnaire.query';
import { GET_PROGRAMCYCLES_QUERY } from '../../graphql/queries/programcycles.query';
import { ListOptionSetsQuery } from '../../graphql/queries/optionsets.query';
import { QUALIFICATION_MUTATION } from './../../graphql/mutations/qualification.mutation';
import { DWELLING_MUTATION } from '../../graphql/mutations/dwelling.mutation';
import {
  CONTACT_HO_MUTATION,
  CONTACT_COOWNER_MUTATION
} from './../../graphql/mutations/contact.mutation';
import { EDIT_DWELLING_MUTATION } from './../../graphql/mutations/dwelling.mutation';
// Interfaces
import { IPolicy } from './../../models/policy.interface';
import { IOwner } from '../../models/owner.interface';
import {
  IDwellingInput,
  IDwellingReturned
} from './../../models/dwellingInput.interface';
import { IProgramCycle } from '../../models/programcycle.interface';
import {
  IQualification,
  IQualificationSubmission
} from '../../models/qualification.interface';
import { IQuestionnaire } from './../../models/questionnaire.interface';
import { IOptions, IOptionSets } from './../../models/optionsets.interface';
import { ListDwellingsQuery } from '../../graphql/queries/dwelling.query';
import { AUTH_QUERY } from '../../graphql/queries/authentication.query';
import { IContact } from '../../models/contact.interface';
import { FormBuilder, Validators } from '@angular/forms';
import { ZipcodeDialogComponent } from './components/zipcode-dialog/zipcode-dialog.component';
import { IApplication } from '../../models/application.interface';
import { ListApplicationsProgramCycleQuery } from '../../graphql/queries/application.query';
import { DialogSolutionDeployingComponent } from '../qualification/components/dialog/dialog-solutiondeploying.component';
import { ListSolutionHistorysQuery } from '../../graphql/queries/solutionhistory.query';
import {
  IAddressgReturned,
  IAddressInput
} from '../../models/addressInput.interface';
import { AddressStandardizeService } from '../../services/address/addressstandardize.service';
import { IDwellingDetectionReturned } from '../../models/dwellingdetection.interface';
import { cloneDeep } from '@apollo/client/utilities/common/cloneDeep';
import { ErrorService } from '../../services/errorinterceptor/error.service';

declare let ga: Function;
declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Component({
  selector: 'ebb-qualification',
  templateUrl: './qualification.component.html',
  styleUrls: ['./qualification.component.scss']
})
export class QualificationComponent implements OnInit {
  public questionnaire$: Subject<IQuestionnaire[]> = new BehaviorSubject(<
    IQuestionnaire[]
  >{});
  public contact$: Observable<IOwner>;
  public dwelling$: Subject<IDwellingReturned> = new BehaviorSubject(<
    IDwellingReturned
  >{});
  public dwellingaddress$: Subject<IAddressgReturned> = new BehaviorSubject(<
    IAddressgReturned
  >{});
  public qualification$: Observable<IQualification>;
  public policies: IOptions[];
  public programCycle: IProgramCycle;
  public programCycles: IProgramCycle[];
  public userPolicy: DialogData | IPolicy;
  public programTypeCodeOptionSet: string;
  public contactId: string;
  public noB2cAccount: boolean;
  public applicationInput: any;
  public responseMessage: string;
  public tooManyAttempts: boolean;
  public contactData: { firstName: string; lastName: string; email: string } = {
    firstName: null,
    lastName: null,
    email: null
  };
  public stepSection = 1;
  public drawerOpen: boolean;
  public drawerContent: IQualificationSubmission;
  public badCode = 0;
  public loading = true;
  public isDwellingFormInvalid = true;
  public isQuestionnaireFormInvalid = true;
  public error: string;
  private dialogRef;
  public dialogRefCount = 0;
  public dwellingNextInProcessComplete = true;
  public activateNextInProcessComplete = true;
  public Questionnaire: IQuestionnaire[];
  constructor(
    private apollo: Apollo,
    private route: ActivatedRoute,
    private authService: AuthService,
    private dwellingService: DwellingService,
    private router: Router,
    private locationStrategy: LocationStrategy,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private readonly dialogSolutionDeploying: MatDialog,
    private addressStandardizeService: AddressStandardizeService,
    private errorService: ErrorService,
  ) {
    this.applicationInput = this.formBuilder.group({
      dwelling: [false, Validators.requiredTrue],
      qualification: [false, Validators.requiredTrue]
    });

    this.route.queryParams.subscribe(params => {
      const programLocalStore = localStorage.getItem('ebbprogram');
      if (window['program']) {
        this.programTypeCodeOptionSet = window['program'];
      } else if (programLocalStore) {
        this.programTypeCodeOptionSet = programLocalStore;
      } else {
        this.programTypeCodeOptionSet = 'FEMA|EBB'; //default to EBB programs
      }
    });
  }

  public ngOnInit(): void {
    this.apollo
      .query({
        query: AUTH_QUERY,
        errorPolicy: 'all'
      })
      .subscribe(_result => {
        var result =cloneDeep(_result)
        const auth = (result.data as any).authentication;
        const contact = (result.data as any).contact as IContact;
        if (auth) {
          this.noB2cAccount = !auth.isVerified;
          this.contactData = {
            ...this.contactData,
            ...{
              email: auth.email
            }
          };
        }
        if (contact) {
          this.contactData = {
            ...this.contactData,
            ...{
              firstName: contact.firstName,
              lastName: contact.lastName
            }
          };
        } else if (
          localStorage.getItem('firstName') &&
          localStorage.getItem('lastName')
        ) {
          this.contactData = {
            ...this.contactData,
            ...{
              firstName: localStorage.getItem('firstName'),
              lastName: localStorage.getItem('lastName')
            }
          };
        }

        if (
          result.errors &&
          result.errors[0] &&
          result.errors[0].message.includes('not authenticated')
        ) {
          console.log('registration qualificationcomponent, not authenticated');
          //redirect to login with any id or email from querystring - so that messaging can be shown there
          this.route.queryParams.subscribe(params => {
            const idParam = params['id'];
            const emailParam = params['email'];
            this.router.navigate(['register', 'login'], {
              queryParams: { id: idParam, email: emailParam }
            });
          });
        } else {
          console.log('registration qualificationcomponent, authenticated');

          this.router.events
            .pipe(
              filter((rs): rs is NavigationEnd => rs instanceof NavigationEnd)
            )
            .subscribe(event => {
              if (event.id === 1 && event.url === event.urlAfterRedirects) {
                this.checkSolutionDeploying();
              }
            });
          this.loadQualificationData();
        }
      });
  }

  public loadQualificationData() {
    this.getProgramCycles().subscribe(programs => {
      const programsSplit = this.programTypeCodeOptionSet.split('|');

      //if mutiple programs are active at the same time then FEMA is selected
      const availablePrograms = programs.filter(program =>
        programsSplit.includes(program.typeCodeOptionSet)
      );
      const availableFemaProgram = availablePrograms.filter(
        program => program.typeCodeOptionSet === 'FEMA'
      )[0];

      if (availableFemaProgram) {
        //get questionare for FEMA
        this.programCycle = availableFemaProgram;
        this.getQuestionnaire(this.programCycle.typeCode).subscribe();
      } else if (availablePrograms[0]) {
        //get first questionare that are active
        this.programCycle = availablePrograms[0];
        this.getQuestionnaire(this.programCycle.typeCode).subscribe();
      }

      if (this.programTypeCodeOptionSet === 'CEA BB') {
        this.getPolicies().subscribe(policies => {
          this.policies = policies['optionSets'].filter(
            (element: IOptionSets) =>
              element.name === 'cea_homeinsuranceprovider'
          )[0].options;
        });
      }

      if (this.programCycle) {
        if (this.programCycle.homeownerOccupied === true) {
          this.programCycles = [this.programCycle];
        } else {
          this.getApplicationsProgramCycles().subscribe(applications => {
            applications = applications.filter(
              application => application.programCycle.homeownerOccupied === true
            );
            if (applications.length > 0) {
              this.programCycles = [applications[0].programCycle];
            }
          });
        }

        this.apollo
          .query({
            query: ListDwellingsQuery,
            errorPolicy: 'all'
          })
          .pipe(
            map(_result => {
              let result = cloneDeep(_result);
              let data = (result.data as any)
                .dwellings as IDwellingReturned[];
              let error = '';
              if (result.errors && result.errors.length > 0) {
                error = result.errors[0].message;
              }
              let selectedDwellings: IDwellingReturned[];
              if (data) {
                selectedDwellings = data.filter(
                  dwelling =>
                    dwelling.statusCode === 1 &&
                    dwelling.stateCode === 0 &&
                    dwelling._Ebb_ProgramCycleId === this.programCycle.id
                );
              }

              if (selectedDwellings && selectedDwellings[0]) {
               
                var name = "addresschange" + selectedDwellings[0].id;
                var addresschange = this.getCookie(name);
            if( addresschange === "true"){
                //this.RemoveQualifications(selectedDwellings);
              }else{
                this.SetQualifications(selectedDwellings);
              }
                return { dwelling: selectedDwellings[0], error: error };
              } else {
                const newDwelling = {} as IDwellingReturned;
                newDwelling._Ebb_ProgramCycleId = this.programCycle.id;
                return { dwelling: newDwelling, error: error };
              }
            }),
            publishReplay(1),
            refCount()
          )
          .subscribe(data => {
            if (data.error) {
              console.error(data.error);
              if (data.error.includes('not authenticated')) {
                //redirect to login with any id or email from querystring - so that messaging can be shown there
                this.route.queryParams.subscribe(params => {
                  const idParam = params['id'];
                  const emailParam = params['email'];
                  this.router.navigate(['register', 'login'], {
                    queryParams: { id: idParam, email: emailParam }
                  });
                });
              }
            }
            this.dwelling$.next(data.dwelling);
            this.loading = false;
          });
      } else {
        this.error =
          'Error: All programs for this registration are currently closed. Please contact us for more information.';
        this.loading = false;
      }
    });
  }

  private SetQualifications( selectedDwellings: IDwellingReturned[]) {
    var qualifications = selectedDwellings[0].qualifications;
    if (qualifications !== null && qualifications.length > 0) {
      qualifications.forEach(qual => {
        var getcookievalue = this.getCookie(
          selectedDwellings[0].id + qual._Ebb_QuestionKey_Value
        );
        if (getcookievalue !== null && getcookievalue !== undefined) {
          qual.response = getcookievalue;
        }
        if (qual.response) {
          if (this.Questionnaire[0].questions.filter(
            x => x.id == qual._Ebb_QuestionKey_Value
          ).length > 0) {
            if (qual.response) {
              var exresponse = this.Questionnaire[0].questions.find(
                x => x.id == qual._Ebb_QuestionKey_Value
              ).qualification;
              var style = 'question-valid';
              if (exresponse) {
                if (!exresponse.includes(qual.response)) {
                  style = 'question-invalid';
                }
              }
              if (this.Questionnaire[0].questions.filter(
                x => x.id == qual._Ebb_QuestionKey_Value &&
                  x.inputTypeOptionSet.toLowerCase() === 'select'
              ).length > 0) {
               
                             

                if (this)
              var  inputValues = this.Questionnaire[0].questions.find(
                x => x.id == qual._Ebb_QuestionKey_Value
              ).inputValue.split(',');
              inputValues = this.trimarray(inputValues);
             
                this.Questionnaire[0].questions.find(
                  x => x.id == qual._Ebb_QuestionKey_Value
                ).inputValue = inputValues.join(",");
                var  qualifications = this.Questionnaire[0].questions.find(
                  x => x.id == qual._Ebb_QuestionKey_Value
                ).qualification.split(',');
                qualifications = this.trimarray(qualifications);
                this.Questionnaire[0].questions.find(
                  x => x.id == qual._Ebb_QuestionKey_Value
                ).qualification =qualifications.join(",");
                       this.Questionnaire[0].questions.find(
                    x => x.id == qual._Ebb_QuestionKey_Value
                  ).inputSelectedValidStyle = style;
                this.Questionnaire[0].questions.find(
                  x => x.id == qual._Ebb_QuestionKey_Value
                ).inputSelectedValue =this.trimstring(qual.response);
              } else {
                this.Questionnaire[0].questions.find(
                  x => x.id == qual._Ebb_QuestionKey_Value
                ).inputSelectedValidStyle = style;
                this.Questionnaire[0].questions.find(
                  x => x.id == qual._Ebb_QuestionKey_Value
                ).inputSelectedValue = this.trimstring(qual.response);
              }
            }
          }
        }
      });
    }
  }
public trimstring (str) {
    str = str.replace(/^\s+/, '');
    for (var i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
            str = str.substring(0, i + 1);
            break;
        }
    }
    return str;
}
public trimarray (stringarray :string[]){
  let array = [];
  stringarray.forEach(str=>{
    str = str.replace(/^\s+/, '');
    for (var i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
            str = str.substring(0, i + 1);
            break;
        }
    }
  array.push(str);});


  return array;
}
  private RemoveQualifications( selectedDwellings: IDwellingReturned[]) {
    var qualifications = selectedDwellings[0].qualifications;
    if (qualifications !== null && qualifications.length > 0) {
      qualifications.forEach(qual => {
        var getcookievalue = this.getCookie(
          selectedDwellings[0].id + qual._Ebb_QuestionKey_Value
        );
        if (getcookievalue !== null && getcookievalue !== undefined) {
         this.eraseCookie(selectedDwellings[0].id + qual._Ebb_QuestionKey_Value) 
        }
      
      });
    }
  }
  private eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  public isDwellingFormInvalidChange(value: boolean): void {
    this.isDwellingFormInvalid = value;
    this.applicationInput.get('dwelling').setValue(!value);
  }

  public isQuestionnaireFormInvalidChange(value: boolean): void {
    this.isQuestionnaireFormInvalid = value;
    this.applicationInput.get('qualification').setValue(!value);
  }

  public changeStepSection(num: number): void {
    console.log('this.noB2cAccount=' + this.noB2cAccount);
    this.stepSection += num;
    this.scrollToTop();
  }

  public scrollToTop() {
    const stepElement = document.getElementById('ebb-stepper-scroller-top');
    if (stepElement) {
      if (this.detectIE11()) {
        //IE11 has issues with scrollIntoView and will scroll html element horizontally
        window.scrollTo(0, stepElement.offsetTop);
      } else {
        setTimeout(() => {
          stepElement.scrollIntoView({
            block: 'start',
            inline: 'nearest',
            behavior: 'smooth'
          });
        }, 250);
      }
    }
  }

  private detectIE11() {
    return window.navigator.userAgent.indexOf('Trident/') > 0;
  }

  /**
   * business logic for handling dwelling save
   * ceabb - need review for policy existing before save
   * @param dwelling
   */
  public handleDwelling(dwelling: IDwellingInput | IDwellingReturned): void {
    const qualified = false;
    const addressdwelling = {} as IAddressInput;
    addressdwelling.addressLine1 = dwelling.address_Street;
    addressdwelling.addressLine2 = dwelling.address_Street_Line2;
    addressdwelling.state = dwelling.address_State;
    addressdwelling.city = dwelling.address_City;
    addressdwelling.zipCode = dwelling.address_Zip;
    
    this.dwellingNextInProcessComplete = false; // Start processing
  
    this.addressStandardizeService.verifyaddress(addressdwelling).subscribe(
      (data: any) => {
        // Handle address standardization response
        dwelling.address_Street = data.addressLine1;
        dwelling.address_Street_Line2 = data.addressLine2 && data.addressLine2 !== 'null' ? data.addressLine2 : '';
        dwelling.address_State = data.state;
        dwelling.address_City = data.city;
        dwelling.address_Zip = data.zipCode.split("-")[0] || data.zipCode;
        dwelling.isAddressStandardized = data.isAddressStandardized;
  
        if (dwelling.pi) {
          this.loading = true;
          this.checkForDwelling(dwelling, qualified).pipe(
            take(1),
            switchMap(success => this.checkForPolicy(dwelling).pipe(
              take(1),
              tap((res: any) => {
                if (res.policy && !res.policy.allowRegistration) {
                  this.router.navigate(['register', 'policy-not-qualified']);
                } else if (res.policy && res.policy.id && res.policy.allowRegistration) {
                  dwelling._Ebb_PolicyId = res.policy.id;
                  this.userPolicy = res.policy as IPolicy;
                  this.checkForDwelling(dwelling, qualified).pipe(
                    take(1),
                    tap(success => {
                      if (success) {
                        this.loading = false;
                        this.dwellingNextInProcessComplete = true; // Complete processing
                        this.changeStepSection(1);
                      } else {
                        this.router.navigate(['register', 'please-contact']);
                      }
                    }),
                    catchError(async (error) => this.handleError(error))
                  ).subscribe();
                } else {
                  if (!res.policy) {
                    this.router.navigate(['register', 'policy-not-found']);
                  }
                }
              }),
              catchError(async (error) => this.handleError(error))
            ))
          ).subscribe(
            () => {
              this.loading = false;
              this.dwellingNextInProcessComplete = true; // Complete processing
            },
            error => this.handleError(error)
          );
        } else {
          this.checkForDwelling(dwelling, qualified).pipe(
            take(1),
            tap(success => {
              if (success) {
                this.loading = false;
                this.dwellingNextInProcessComplete = true; // Complete processing
                this.changeStepSection(1);
              } else {
                this.router.navigate(['register', 'please-contact']);
              }
            }),
            catchError(async (error) => this.handleError(error))
          ).subscribe(
            () => {
              this.loading = false;
              this.dwellingNextInProcessComplete = true; // Complete processing
            },
            error => this.handleError(error)
          );
        }
      },
      error => this.handleError(error)
    );
  }
  
  private handleError(error: any): void {
    this.loading = false;
    this.dwellingNextInProcessComplete = true; // Ensure completion on error
    if (error.toString().includes('modified-zip:')) {
      const zipcode = error.toString().substring(13);
      this.openZipDialog(zipcode);
    } else {
      this.error = error;
    }
  }
  
  private setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }
  /**
   * Check for Dwelling and save if there are no issues
   * @param dwelling
   */
  public checkForDwelling(
    dwelling: IDwellingInput,
    qualified: boolean
  ): Observable<boolean> {
    return new Observable(observer => {
      this.dwellingService
        .checkForDwelling(
          dwelling,
          this.programCycle.typeCode,
          this.contactData.email
        )
        .pipe(take(1))
        .subscribe((dwellingExists: IDwellingDetectionReturned) => {
          if (dwellingExists.duplicatefound) {
            if (this.programCycle.typeCode === 700000003) {
              this.setCookie('esserrormessage', dwellingExists.errormessage, 1);
            } else {
              this.setCookie('ebberrormessage', dwellingExists.errormessage, 1);
            }
            observer.next(false);
            observer.complete();
          } else {
            this.saveDwelling(dwelling, dwellingExists.dwellingId)
              .pipe(take(1))
              .subscribe(
                res => {
                  dwelling['id'] = res.id;
                  this.dwelling$.next(res);
                  if (dwelling.address_Zip !== res.address_Zip) {
                    observer.error('modified-zip:' + res.address_Zip);
                    return;
                  } else {
                    setTimeout(() => {
                      observer.next(!this.isDwellingFormInvalid);
                      observer.complete();
                    }, 5000);
                  }
                },
                error => {
                  observer.error(error);
                }
              );
          }
        });
    });
  }

  public saveDwelling(
    dwellingInput: IDwellingReturned | IDwellingInput,
    dwellingId: string
  ): Observable<IDwellingReturned> {
   
    this.drawerContent = null;
  
    const dwellingSave = { ...dwellingInput };
    this.loading = true;
    dwellingSave.yearBuilt = dwellingSave.yearBuilt.toString();

    if(dwellingSave.numberOfUnits != null){
    var units =  dwellingSave.numberOfUnits.toString();;
      dwellingSave.numberOfUnits =  parseInt(units, 10);
    }
    if(dwellingSave.squareFootage != null){
      var units =  dwellingSave.squareFootage.toString();;
        dwellingSave.squareFootage =  parseInt(units, 10);
      }
  
    if (dwellingSave.pi) {
      delete dwellingSave['pi'];
    }
  
    if (dwellingSave.sys_EnrollmentError || dwellingSave.sys_EnrollmentError === null) {
      delete dwellingSave['sys_EnrollmentError'];
    }
    
    if (dwellingSave['id']) {
      dwellingId = dwellingSave['id'];
      delete dwellingSave['id'];
    }
  
    delete dwellingSave['__typename'];
  
    return new Observable(observer => {
      this.apollo
        .mutate({
          mutation: EDIT_DWELLING_MUTATION,
          errorPolicy: 'all',
          variables: {
            dwellingInput: dwellingSave,
            dwellingId
          }
        })
        .pipe(
          catchError(error => {
            observer.error('Error: ' + error.message);
            return of(null);
          }),
          switchMap(response => {
            if (response.errors && response.errors[0]) {
              const errorMessage = response.errors[0].message;
              if (errorMessage.includes('not authenticated') ||errorMessage.includes('not authorized for this dwelling')) {
                this.reDirectLandingPage(response.errors[0]);
                observer.error(errorMessage);
                return of(null);
              } else {
                observer.error('Error: ' + errorMessage);
                return of(null);
              }
            }
  
            const returndata = response.data['saveDwelling'] as IDwellingReturned;
            if (returndata.sys_EnrollmentError && returndata.sys_EnrollmentError !== 'false') {
              let enrollmentError = returndata.sys_EnrollmentError;
              if (enrollmentError === 'Dwelling address or APN already exists in qualified or accepted state') {
                enrollmentError = 'There is a problem registering this address.';
              }
              observer.error('Error: ' + enrollmentError);
              return of(null);
            }
  
            observer.next(returndata);
            observer.complete();
            
            return of(returndata);
          })
        ).subscribe();
    });
  }

  public qualifyDwelling(
    dwellingInput: IDwellingReturned
  ): Observable<IDwellingReturned> {
    
    this.drawerContent = null;
    this.loading = true;
  
    let dwellingId: string;
    const dwellingSave: any = {};
  
    dwellingSave.statusCode = 700000000; // qualified
    dwellingSave._Ebb_ProgramCycleId = this.programCycle.id;
  
    if (dwellingInput['id']) {
      dwellingId = dwellingInput['id'];
    } else {
      return of(null);
    }
  
    delete dwellingSave['__typename'];
  
    return new Observable(observer => {
      this.apollo
        .mutate({
          mutation: EDIT_DWELLING_MUTATION,
          errorPolicy: 'all',
          variables: {
            dwellingInput: dwellingSave,
            dwellingId
          }
        })
        .pipe(
          catchError(error => {
            observer.error('Error: ' + error.message);
            return of(null);
          }),
          switchMap(response => {
            if (response.errors && response.errors[0]) {
              observer.error('Error: ' + response.errors[0].message);
              return of(null);
            }
  
            const returndata = response.data['saveDwelling'] as IDwellingReturned;
            observer.next(returndata);
            observer.complete();
           
            return of(returndata);
          })
        ).subscribe();
    });
  }

  public checkForPolicy(dwelling: IDwellingInput): Observable<IPolicy> {
    return this.apollo
      .query({
        query: POLICY_QUERY,
        variables: {
          address1_Line1: dwelling.address_Street,
          address1_Line2: dwelling.address_Street_Line2,
          address1_City: dwelling.address_City,
          address1_PostalCode: dwelling.address_Zip,
          pi: Number(dwelling.pi)
        }
      })
      .pipe(map(result => result.data as IPolicy));
  }

  public submitQualification(qualification: IQualificationSubmission): void {
    let crmQualificationArray: string[];

    const saveQualification: IQualificationSubmission = { ...qualification };
    delete saveQualification.crmQualification;
    delete saveQualification.crmQualificationError;
    delete saveQualification.crmQualificationHelp;
    this.drawerOpen = false;

    //more info does not set a response
    if (qualification.response === null) {
      this.drawerContent = qualification;
      return;
    }

    this.dwelling$
    .subscribe(dwelling => {
      qualification._Ebb_DwellingKey_Value = dwelling.id;
      this.apollo
        .mutate({
          mutation: QUALIFICATION_MUTATION,
          variables: { qualification: saveQualification }
        })
        .pipe(
          map(result => cloneDeep(result.data as IQualification)),
          catchError((error) => {
            var name = saveQualification._Ebb_DwellingKey_Value + saveQualification._Ebb_QuestionKey_Value;
            this.eraseCookie(name);
            if (error.message.includes('not authenticated') ||error.message.includes('not authorized for this dwelling') ) {
                      return this.reDirectLandingPage(error); 
            } else {
              // if(error.message.includes('Unknown Error')){
              //   location.reload();
              // }
              
              return ; // Return an observable with a null value to keep the stream alive
            }
          })
        )
        .subscribe(_res => {

            
          var res =cloneDeep(_res);
                      if (qualification.crmQualification.indexOf(',') > -1) {
                        //other response loophole
                        let val = res['saveQualification'].response.trim();
                        if (
                          res['saveQualification'].name === 'Source' &&
                          val.indexOf('Other - ') >= 0
                        ) {
                          val = 'Other';
                        }
          
                        crmQualificationArray = qualification.crmQualification.split(',');
                        for (let i = 0; i < crmQualificationArray.length; i++) {
                          crmQualificationArray[i] = crmQualificationArray[i].trim();
                        }
                        //crmQualificationArray.forEach(qual => qual.trim());
          
                        if (!crmQualificationArray.includes(val)) {
                          this.drawerContent = qualification;
                          this.updateQuestionStatus(saveQualification, false);
                        } else {
                          this.drawerContent = null;
                          this.updateQuestionStatus(saveQualification, true);
                        }
                      } else {
                        if (
                          qualification.crmQualification !==
                          res['saveQualification'].response
                        ) {
                          this.drawerContent = qualification;
                          this.updateQuestionStatus(saveQualification, false);
                        } else {
                          this.drawerContent = null;
                          this.updateQuestionStatus(saveQualification, true);
                        }
                      }
                    });
                })
                .unsubscribe();
  }

  public getQuestionnaire(typeCode: number): Observable<boolean> {
    return new Observable(observer => {
      this.apollo
        .query({
          query: GET_QUESTIONNAIRES_QUERY,
          variables: { typeCode }
        })
        .pipe(map(result => result.data as any))
        .subscribe(x => {
          const questionniareArray = cloneDeep( x.questionnaires as IQuestionnaire[]);
          if (questionniareArray) {
            this.Questionnaire = questionniareArray;
            this.questionnaire$.next(questionniareArray);
            observer.next(true);
            observer.complete();
          } else {
            this.questionnaire$.next([]);
            observer.next(false);
            observer.complete();
          }
        });
    });
  }

  public updateQuestionStatus(
    saveQualification: IQualificationSubmission,
    isValid: boolean
  ) {
    //update questionnaire$
    this.questionnaire$
      .pipe(take(1))
      .subscribe(_x => {
      var x = cloneDeep(_x);
        const question = x[0].questions.filter(
          y => y.id === saveQualification._Ebb_QuestionKey_Value
        )[0];
       
        if (question) {
          question.inputSelectedValue = saveQualification.response;
          question.inputSelectedValidStyle = isValid
            ? 'question-valid'
            : 'question-invalid';

          //now we have to revert other back
          if (
            isValid &&
            saveQualification.name === 'Source' &&
            saveQualification.response.indexOf('Other - ') >= 0
          ) {
            question.inputSelectedValue = ' Other';
            question.inputValueOther = saveQualification.response.substr(
              saveQualification.response.indexOf('-') + 2
            );
          }
          
          this.questionnaire$.next(x);
        }
      })
      .unsubscribe();
  }

  public getProgramCycles(): Observable<IProgramCycle[]> {
    return this.apollo
      .query({
        query: GET_PROGRAMCYCLES_QUERY,
        fetchPolicy: 'network-only'
      })
      .pipe(
        map(result => {
          return result.data['programcyclescanregister'] as IProgramCycle[];
        })
      );
  }

  public getApplicationsProgramCycles(): Observable<IApplication[]> {
    return this.apollo
      .query({
        query: ListApplicationsProgramCycleQuery
      })
      .pipe(
        map(result => {
          return result.data['applications'] as IApplication[];
        })
      );
  }

  public getPolicies(): Observable<IOptionSets[]> {
    return this.apollo
      .query({
        query: ListOptionSetsQuery,
        variables: { name: 'policy' }
      })
      .pipe(map(result => result.data as IOptionSets[]));
  }

  public submitContact(ownerForm: IOwner): Observable<IOwner> {
    let contact: any;

    if (ownerForm.address1) {
      contact = { ...ownerForm.owner, ...ownerForm.address1 };
    } else {
      contact = { ...ownerForm.owner };
    }

    //co-owner
    if (ownerForm.coowner) {
      this.dwelling$.pipe(first()).subscribe(dwelling => {
        const dwellingSave = Object.assign({ ...dwelling }, ownerForm.coowner);
        const dwellingId: string = dwelling.id;
        delete dwellingSave['id'];
        delete dwellingSave['__typename'];
        delete dwellingSave['sys_EnrollmentError'];

        const coowner = this.apollo
          .mutate({
            mutation: CONTACT_COOWNER_MUTATION,
            variables: {
              dwellingInput: dwellingSave,
              dwellingId: dwellingId
            }
          })
          .pipe(map(result => result.data as any), catchError((error) => {
            return this.reDirectLandingPage(error); 
          }));

        coowner
          .pipe(first())
          .subscribe(co => console.log('co-owner update', co));
      });
    }

    //save contact
    this.contact$ = this.apollo
      .mutate({
        mutation: CONTACT_HO_MUTATION,
        variables: { contact }
      })
      .pipe(map(result => result.data as IOwner), catchError((error) => {
        return this.reDirectLandingPage(error); 
      }));

    this.contact$.pipe(first()).subscribe(() => {
      if (!this.noB2cAccount) {
        this.dwelling$.pipe(first()).subscribe(dwelling => {
          //mark dwelling as approved
          this.qualifyDwelling(dwelling)
            .pipe(first()        
          )
            .subscribe(
              () => {             
               // route to reg complete and then refresh page - host site can take over route
                this.router
                  .navigate(['/complete'], {
                    skipLocationChange: true,
                    queryParams: { loading: true }
                  })
                  .then(() => {
                    //stay logged in but redirect
                    const redirectEndpoint = this.router.url
                      .split('?')[0]
                      .replace('//', '/');
                    this.authService
                      .completeRedirect(redirectEndpoint)
                      .subscribe(url => {
                        document.location.href = url;
                      });
                  });
              },
              error => {
                this.loading = false;
                this.error = error;
              }
            );
        });
      }
    });

    return this.contact$;
  }

  private reDirectLandingPage(error: any) {
    if (error.message.includes('not authenticated')) {

         this.route.queryParams.subscribe(params => {
        const idParam = params['id'];
        const emailParam = params['email'];
        this.router.navigate(['register', 'login'], {
          queryParams: { id: idParam, email: emailParam }
        });
      });
      
    }
    else if (error.message.includes('not authorized for this dwelling')){
      const redirectEndpoint = (this.router.url.split('?')[0]).replace('//','/' );
      this.authService.logout(redirectEndpoint).subscribe(url => {
      document.location.href = url;
    });
      
    }
    else {
      // Optionally handle other errors here or use the error service to show an error message
    }
    return of(null);
  }

  public createAccount(accountInfo: any): void {
    this.activateNextInProcessComplete = false;
    if (this.responseMessage) {
      this.responseMessage = '';
    }
  
    this.authService.createAccountFromGuest(accountInfo).subscribe(res => {
      if (res.message && res.message !== 'success') {
        if (res.message === 'bad email code' && this.badCode < 3) {
          this.badCode++;
          this.responseMessage = res.message;
        } else if (res.message === 'bad email code' && this.badCode > 2) {
          this.responseMessage = 'There have been too many requests to verify this email address. Please wait 5 minutes, then try again.';
          this.tooManyAttempts = true;
          setTimeout(() => {
            this.badCode = 0;
            this.tooManyAttempts = false;
            this.responseMessage = '';
          }, 300000);
        } else {
          this.responseMessage = res.message;
        }
        this.activateNextInProcessComplete = true;
      } else {
        this.dwelling$.subscribe(dwelling => {
          this.qualifyDwelling(dwelling).subscribe(
            () => {
              if (typeof ga !== 'undefined') {
                ga('send', {
                  hitType: 'event',
                  eventCategory: 'button',
                  eventAction: 'b2clogin',
                  eventLabel: 'successful homeowner registration',
                  value: 1
                });
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: 'HomeownerRegistrationComplete'
                });
              }
              this.router.navigate(['/complete'], {
                skipLocationChange: true,
                queryParams: { loading: true }
              }).then(() => {
                const redirectEndpoint = this.router.url.split('?')[0].replace('//', '/');
                this.authService.logout(redirectEndpoint).subscribe(url => {
                  // document.location.href = url;
                });
              });
            },
            error => {
              this.loading = false;
              this.error = error;
             
            }
          );
        });
      }
    });
  }

  public loadingEvent(event: boolean): void {
    this.loading = event;
  }

  public openZipDialog(zipcode: string): void {
    const dialogRef = this.dialog.open(ZipcodeDialogComponent, {
      data: {
        address1_PostalCode: zipcode
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('here we go!');
      }
    });
  }

  // If a D365 solution is being deployed/imported, detect this and inform the user.
  private checkSolutionDeploying() {
    // Perform deployment status check, once.
    this.checkForDeployment().subscribe(
      anyIncompleteImportJobs => {
        if (anyIncompleteImportJobs && this.dialogRefCount <= 0) {
          this.dialogRef = this.dialogSolutionDeploying.open(
            DialogSolutionDeployingComponent,
            {
              width: '400px',
              disableClose: true
            }
          );
          this.dialogRefCount++;
        }
      },
      error =>
        console.error(
          `ERROR: QualificationComponent.checkSolutionDeploying() - ${error}`
        )
    );

    // Set up periodic deployment status checks.
    setInterval(() => {
      this.checkForDeployment().subscribe(
        solutionsDeploying => {
          if (solutionsDeploying && this.dialogRefCount <= 0) {
            this.dialogRef = this.dialogSolutionDeploying.open(
              DialogSolutionDeployingComponent,
              {
                width: '400px',
                disableClose: true
              }
            );
            this.dialogRefCount++;
          } else {
            if (!solutionsDeploying && this.dialogRefCount > 0) {
              this.dialogRef.close();
              this.dialogRefCount = 0;
            }
          }
        },
        error =>
          console.error(
            `ERROR: QualificationComponent.checkSolutionDeploying()2 - ${error}`
          )
      );
    }, 60000);
  }

  public checkForDeployment(): Observable<boolean> {
    return new Observable(observer => {
      this.apollo
        .query({
          query: ListSolutionHistorysQuery,
          fetchPolicy: 'network-only'
        })
        .pipe(map(result => result.data as any))
        .subscribe(x => {
          const solutionsDeploying = cloneDeep( x.solutionhistorys as ISolutionHistory[]);
          if (solutionsDeploying.length > 0) {
            observer.next(true);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        });
    });
  }
  private getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
}
